import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import useWindowDimensions from '../../../core/hooks/useWindowDimensions'

import styles from './SearchLine.module.scss'

type TypeItemsProps = 'city' | 'metro' | 'cats' | 'date' | 'square' | 'rating' | 'stocks' | 'price'

interface ItemProps {
	type: TypeItemsProps
	value: any
	onChange: (value: any) => void
	onClick: () => void
	onBlur: () => void
	onFocus: () => void
	disabled?: boolean
	dateOnClick?: () => void
}

const Item: FC<ItemProps> = ({ type, value, onChange, onClick, onBlur, onFocus, disabled = false, dateOnClick }) => {
	const { formatMessage: f } = useIntl()
	const { width } = useWindowDimensions()
	const isMobile = width > 768

	return (
		<>
			<div
				className={
					styles.search_input + (disabled ? ' ' + styles.disabled : '') + (isMobile ? ' ' + styles.mobile : '')
				}
				onClick={onClick}
			>
				{type == 'date' || type == 'price' || type == 'square' ? (
					<input
						id={`sl_${type}`}
						name={`sl_${type}`}
						type='text'
						placeholder={type == 'date' ? '__ /__ /____' : ''}
						value={value}
						onClick={dateOnClick}
					/>
				) : type == 'rating' ? (
					<div onClick={dateOnClick} className={styles.rating_container}>
						{value}
					</div>
				) : (
					<input
						id={`sl_${type}`}
						name={`sl_${type}`}
						type='text'
						placeholder={f({ id: 'studios_srch_' + type })}
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						onFocus={onFocus}
						disabled={disabled}
					/>
				)}
			</div>
		</>
	)
}

export default observer(Item)
